// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1-gHR","item":"PaymentsMobile_item__4xmxr","label":"PaymentsMobile_label__3Nfo_","amount":"PaymentsMobile_amount__232F_"};